import PropTypes from 'prop-types';
import { HashRouter } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';
import { Provider } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';
import VacationFinderBase from '../vacationFinderBase';
import '../styles/style.scss';

const VacationFinder = ({ isServer, store }) => {
  if (!isServer) {
    // el.scroll.behaviour = 'smooth' is not supported by iOS and older browsers
    smoothscroll.polyfill();
  }

  const Router = isServer ? StaticRouter : HashRouter;

  return (
    <Provider store={store}>
      <Router>
        <VacationFinderBase isServer={isServer} />
      </Router>
    </Provider>
  );
};

VacationFinder.propTypes = {
  store: PropTypes.shape({}).isRequired,
  isServer: PropTypes.bool,
};

VacationFinder.defaultProps = {
  isServer: false,
};

export default VacationFinder;
